<template>
  <div class="view-container">
    <form class="payment-result-form">
      <img v-if="success == null"
        src="@/assets/Loading_icon.gif"
        class="loader-icon"
        width="250"
        height="150"
        alt="Loading..."
      />
      <div v-else>
        <h1>{{ success ? "Success" : "Cancelled" }}</h1>
        <span
          >Your payment has been
          {{ success ? "successfull" : "cancelled" }}.</span
        >
        <br /><br />
        <a class="btn btn-primary" href="/menu">Continue Ordering</a>
      </div>
    </form>
  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "TransactionCompleted",
  components: {},
  data() {
    return {
      franchiseID: this.$route.query.fid,
      branchID: this.$route.query.bid,
      invoiceNo: this.$route.query.invNo,
      success: null,
    };
  },
  created() {
    var _self = this;

    var paymentData = {
      FranchiseID: _self.franchiseID,
      BranchID: _self.branchID,
      ReferenceNo: _self.invoiceNo,
    };
    _self.initPayApi(_self.$franchiseID);
    _self.$payApi.pay.payment.get.v1(paymentData).then(function (response) {
      _self.success = response.data.purchaseOrderStatusName == "Completed";
      _self.clearPayComputed();
    });
  },
};
</script>
